import { IGAPIDataState } from "../lib/GAPIData";
import { IStockData } from "./StocksApi";

export const STOCK_DATA_MAX_AGE_SECONDS = 60;

export interface IStocksStore {
  stockData?: IGAPIDataState<IStockData>;
}
